import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '../layout/index';
import Login from '../views/login/index';
import Business from '../views/BusinessManage';
import BusinessAdd from '../views/BusinessManage/pages/addAndEdit';
import Service from '../views/ServiceManage';
import ServiceAdd from '../views/ServiceManage/pages/addAndEdit';

import enterpriseBrand from '../views/enterpriseBrand';
import enterpriseBrandAdd from '../views/enterpriseBrand/pages/editAndAdd';

import Account from '../views/AccountManege';
import Agreement from '../views/AgreementManage';
import Type from '../views/TypeManage';
import typeAdd from '../views/TypeManage/pages/addAndEdit';
import Report from '../views/ReportManage';
import Activity from '../views/ActivityManage';
import ActivityConfig from '../views/ActivityConfig';
import ActivityConfigAdd from '../views/ActivityConfig/pages/editAndAdd';
import Message from '../views/MessageManage';
import Section from '../views/SectionManage';
import Rank from '../views/RankManage';
import Column from '../views/ColumnManage';
import Adver from '../views/AdverManage';
import AdverPage from '../views/AdverManage/pages/index';
import Article from '../views/Resource/ArticleList';
import ArticleAdd from '../views/Resource/ArticleList/pages/index';
import Video from '../views/Resource/video';
import VideoAdd from '../views/Resource/video/pages/index';
import PromoteFeed from '../views/Resource/PromoteFeed';
const QuestionReport = () => import('../views/Resource/QuestionReport/index.vue');
const Template = () => import('../views/Resource/TemplateReport/index.vue');
import Question from '../views/Resource/question';
import AnswerList from '../views/Resource/question/pages/index';
import Label from '../views/Resource/label';
import Promoter from '../views/Account/PromoterManage';
import Doctor from '../views/Account/doctor';
import Score from '../views/Finance/score/index';
import Cash from '../views/Finance/cash/index';
import Task from '../views/Task/taskList/index';
import TaskAdd from '../views/Task/taskList/pages/index';
import TaskCheck from '../views/Task/taskList/pages/review';
import Research from '../views/Task/researchFeed/index';
import Web from '../views/Setting/web/index';

import AuthAndArea from './AuthAndArea';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/business',
    children: [
      {
        path: '/business',
        name: '药企管理',
        component: Business,
        meta: [{ name: '药企管理' }],
      },
      {
        path: '/business/add',
        name: '新增企业',
        component: BusinessAdd,
        meta: [{ name: '药企管理', path: '/business' }, { name: '新增企业' }],
      },
      // TODO:
      {
        path: '/business/edit',
        name: '编辑企业',
        component: BusinessAdd,
        meta: [{ name: '药企管理', path: '/business' }, { name: '编辑企业' }],
      },
      {
        path: '/service',
        name: '服务商管理',
        component: Service,
        meta: [{ name: '服务商管理' }],
      },
      {
        path: '/service/add',
        name: '新增服务商',
        component: ServiceAdd,
        meta: [
          { name: '服务商管理', path: '/service' },
          { name: '新增服务商' },
        ],
      },
	  {
	    path: '/enterpriseBrand',
	    name: '企业库管理',
	    component: enterpriseBrand,
	    meta: [{ name: '企业库管理' }],
	  },
	  {
	    path: '/enterpriseBrand/add',
	    name: '新增企业库',
	    component: enterpriseBrandAdd,
	    meta: [
	      { name: '企业库管理', path: '/enterpriseBrand' },
	      { name: '新增企业库' },
	    ],
	  },
      {
        path: '/account',
        name: '账号管理',
        component: Account,
        meta: [{ name: '账号管理' }],
      },
      {
        path: '/agreement',
        name: '协议管理',
        component: Agreement,
        meta: [{ name: '协议管理' }],
      },
      {
        path: '/type',
        name: '类型管理',
        component: Type,
        meta: [{ name: '类型管理' }],
      },
      {
        path: '/type/add',
        name: '添加类型',
        component: typeAdd,
        meta: [
          { name: '类型管理', path: '/type' },
          { name: '表单配置' },
        ],
      },
      {
        path: '/report',
        name: '报告模板管理',
        component: Report,
      },
      {
        path: '/activity',
        name: '服务活动管理',
        component: Activity,
        meta: [{ name: '服务活动管理' }],
      },
      {
        path: '/activityConfig',
        name: '报告表单配置',
        component: ActivityConfig,
        meta: [{ name: '报告表单配置' }],
      },
      {
        path: '/activityConfig/input',
        name: '表单配置',
        component: ActivityConfigAdd,
        meta: [
          { name: '服务活动配置', path: '/activityConfig' },
          { name: '表单配置' },
        ],
      },
      {
        path: '/message',
        name: '消息管理',
        component: Message,
        meta: [{ name: '消息管理' }],
      },
      {
        path: '/section',
        name: '科室管理',
        component: Section,
        meta: [{ name: '科室管理' }],
      },
      {
        path: '/rank',
        name: '职称管理',
        component: Rank,
        meta: [{ name: '职称管理' }],
      },
      {
        path: '/column',
        name: '栏目管理',
        component: Column,
        meta: [{ name: '栏目管理' }],
      },
      {
        path: '/adver',
        name: '广告管理',
        component: Adver,
        meta: [{ name: '广告管理' }],
      },
      {
        path: '/adverPage',
        name: '广告页管理',
        component: AdverPage,
        meta: [{ name: '广告管理', path: '/adver' }, { name: '广告页管理' }],
      },
      {
        path: '/article',
        name: '文章管理',
        component: Article,
        meta: [{ name: '文章管理' }],
      },
      {
        path: '/article/add',
        name: '新增文章',
        component: ArticleAdd,
        meta: [{ name: '文章管理', path: '/article' }, { name: '新增文章' }],
      },
      {
        path: '/video',
        name: '视频管理',
        component: Video,
        meta: [{ name: '视频管理' }],
      },
      {
        path: '/video/add',
        name: '新增视频',
        component: VideoAdd,
        meta: [{ name: '视频管理', path: '/video' }, {name: '新增视频'}],
      },
      {
        path: '/questionReport',
        name: '调研题库',
        component: QuestionReport,
        meta: [{ name: '调研题库' }],
      },
      {
        path: '/templateReport',
        name: '调研模板',
        component: Template,
        meta: [{ name: '调研模板' }],
      },
      {
        path: '/promotefeed',
        name: '推广反馈',
        component: PromoteFeed,
        meta: [{ name: '推广反馈' }],
      },
      {
        path: '/question',
        name: '疑问解答',
        component: Question,
        meta: [{ name: '疑问解答' }],
      },
      {
        path: '/question/answer',
        name: '回复列表',
        component: AnswerList,
        meta: [{ name: '疑问解答', path: '/question' }, {name: '回复列表'}],
      },
      {
        path: '/label',
        name: '标签管理',
        component: Label,
        meta: [{ name: '标签管理' }],
      },
      {
        path: '/promoter',
        name: '推广员管理',
        component: Promoter,
        meta: [{ name: '推广员管理' }],
      },
      {
        path: '/doctor',
        name: '医生管理',
        component: Doctor,
        meta: [{ name: '医生管理' }],
      },
      {
        path: '/score',
        name: '积分管理',
        component: Score,
        meta: [{ name: '积分管理' }],
      },
      {
        path: '/cash',
        name: '提现列表',
        component: Cash,
        meta: [{ name: '提现列表' }],
      },
      {
        path: '/task',
        name: '任务列表',
        component: Task,
        meta: [{ name: '任务列表' }],
      },
      {
        path: '/task/add',
        name: '新增任务',
        component: TaskAdd,
        meta: [{ name: '任务列表', path: '/task' }, {name: '新增任务'}],
      },
      {
        path: '/task/edit',
        name: '编辑任务',
        component: TaskAdd,
        meta: [{ name: '任务列表', path: '/task' }, {name: '编辑任务'}],
      },
      {
        path: '/task/check',
        name: '审核任务',
        component: TaskCheck,
        meta: [{ name: '任务列表', path: '/task' }, {name: '审核任务'}],
      },
      {
        path: '/research',
        name: '调研反馈',
        component: Research,
        meta: [{ name: '调研反馈' }],
      },
      {
        path: '/web',
        name: '网站信息',
        component: Web,
        meta: [{ name: '网站信息' }],
      },
      ...AuthAndArea,
    ],
  },
  {
    path: '/login',
    component: Login,
  },
  // {
  //   path: '/about',
  //   name: 'about',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
];

const router = new VueRouter({
  routes,
});
// 判断登录
router.beforeEach((from, to, next) => {
  if (from.path !== '/login' && !localStorage.getItem('token')) {
    router.replace('/login');
  }
  next();
});

export default router;
